import React from 'react';

import ReactTable from "react-table";
import "react-table/react-table.css";
import Paper from '@material-ui/core/Paper';
import _ from "lodash";
import Add from '@material-ui/icons/AddCircleOutline';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SaveIcon from '@material-ui/icons/Save';
import withFixedColumns from "react-table-hoc-fixed-columns";

import Header from './Header';
import DocumentBulkUpdate from './DocumentBulkUpdate';
import api from '../api/api';

const ReactTableFixedColumns = withFixedColumns(ReactTable);

const requestData = (pageSize, page, sorted, filtered, rawData) => {
  return new Promise((resolve, reject) => {
    // You can retrieve your data however you want, in this case, we will just use some local data.
    let filteredData = rawData;
    // You can use the filters in your request, but you are responsible for applying them.
    if (filtered.length) {
      filteredData = filtered.reduce((filteredSoFar, nextFilter) => {
        return filteredSoFar.filter(row => {
          var reg = new RegExp(nextFilter.value,"i");;
          return !!((row[nextFilter.id] + "").match(reg));
        });
      }, filteredData);
    }
    // You can also use the sorting in your request, but again, you are responsible for applying it.
    const sortedData = _.orderBy(
      filteredData,
      sorted.map(sort => {
        return row => {
          if (row[sort.id] === null || row[sort.id] === undefined) {
            return -Infinity;
          }
          return typeof row[sort.id] === "string"
            ? row[sort.id].toLowerCase()
            : row[sort.id];
        };
      }),
      sorted.map(d => (d.desc ? "desc" : "asc"))
    );

    // You must return an object containing the rows of the current page, and optionally the total pages number.
    const res = {
      rows: sortedData.slice(pageSize * page, pageSize * page + pageSize),
      pages: Math.ceil(filteredData.length / pageSize)
    };
    // Here we'll simulate a server response with 500ms of delay.
    setTimeout(() => resolve(res), 1);
  });
};

export default class DocumentList extends React.Component {

  constructor() { 
    super();
    this.state = {
      obj :''  ,
      rawData:null,
      data: [],
      pages: null,
      loading: true,
      error:'',
      selected: [],
      selectAll: 0,
      checked: [],
      anchorEl: null,
      changeAssignment: false,
      open: false
    } 
    this.fetchData = this.fetchData.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
  }

  fetchData(state, instance) {
    this.setState({ loading: true, fetchDataState: state });
    if(!!this.state.rawData) {
      requestData(
        state.pageSize,
        state.page,
        state.sorted,
        state.filtered,
        this.state.rawData
      ).then(res => {
        // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
        this.setState({
          data: res.rows,
          pages: res.pages,
          loading: false
        });
      });
    }
  }
    
  componentWillMount() {
    var companyCode = '001';
    // Invoke get user details API
    api.getDocumentList(companyCode).then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res) {
            this.setState({
              rawData: res.documents,
              pages: Math.ceil(res.documents / 10),
              loading: false
            });
            this.fetchData(this.state.fetchDataState);
          }
          else {
            this.setState({
              error: "Something went wrong. Please contact site administrator"
            });
          }
       });
      }
   });
  }

	toggleRow(document_control_no) {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[document_control_no] = !this.state.selected[document_control_no];
    var a = this.state.checked.indexOf(document_control_no);
    if (a >= 0){
      var checkedValues = this.state.checked;
      var filtered = checkedValues.filter(function(value, index, arr){
        return value !== document_control_no;
      });
      this.setState({
        checked: filtered,
        selected: newSelected,
        selectAll: 2
      });
      return;
    }
    else{
      this.setState({
        checked: [...this.state.checked, document_control_no],
        selected: newSelected,
        selectAll: 2
      });
    }
	}

  toggleSelectAll = () => {
    let newSelected = [];
    let allCheckedList = [];
		if (this.state.selectAll === 0) {
			this.state.data.forEach(x => {
        newSelected[x.document_control_no] = true;
        allCheckedList.push(x.document_control_no);
			});
		}
		this.setState({
      checked: allCheckedList,
			selected: newSelected,
			selectAll: this.state.selectAll === 0 ? 1 : 0
		});
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onClick = (event) => {
    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  changeAssignment = () => {
    this.setState({ changeAssignment: true });
  };

  render() {
    const { data, pages, loading } = this.state;
    const style = {
      padding: "20px",
    };
    var height= {height: ""};
    if (this.state.data.length >= 10) {
      height = {height: "500px"}
    }
    return (
      <div>
        <Header />
        <div className="page">
          {!this.state.changeAssignment &&
            <Paper style={style}>
              <div style={{float:"right"}}>
                <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '200px'}} href={"/add-document"} >
                  <Add />&nbsp;&nbsp;Add Document
                </Button>
              </div>
              <h2 style= {{color:"#4e5b70"}}><legend>Documents List</legend></h2>
              <p style={{color:"red"}}>{this.state.error}</p>
              <ReactTableFixedColumns
                columns={[
                  {
                    id: "checkbox",
                    accessor: "",
                    Cell: ({ original }) => {
                      return (
                        <input
                          type="checkbox"
                          className="checkbox"
                          checked={this.state.selected[original.document_control_no] === true}
                          onChange={() => this.toggleRow(original.document_control_no)}
                        />
                      );
                    },
                    Header: x => {
                      return (
                        <input
                          type="checkbox"
                          className="checkbox"
                          checked={this.state.selectAll === 1}
                          ref={input => {
                            if (input) {
                              input.indeterminate = this.state.selectAll === 2;
                            }
                          }}
                          onChange={() => this.toggleSelectAll()}
                        />
                      );
                    },
                    fixed: "left",
                    sortable: false,
                    filterable: false,
                    width: 45,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Document Control No",
                    accessor: "document_control_no",
                    id: "edit",
                    Cell: ({value}) => (<a style = {{textDecoration: 'none', color: '#0066c0'}} href={'/update-document/' + value}>{value}</a>),
                    width: 170,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "VHD Received Date",
                    accessor: "vhd_received_date",
                    width: 150,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Gate Entry No",
                    accessor:"gate_entry_no",
                    width: 150,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Gate Entry Date",
                    accessor:"gate_entry_date",
                    width:150,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "SAP Gate entry No",
                    accessor:"sap_gate_entry_no",
                    width: 150,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "SAP Gate Entry Date",
                    accessor: "sap_gate_entry_date",
                    width: 150,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "PC No/Dc No",
                    accessor: "pc_no_dc_no",
                    width: 120,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "PC/DC Date",
                    accessor: "pc_dc_date",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Project Name",
                    accessor:"project_name",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Document Type",
                    accessor: "document_type",
                    width: 120,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Nature of Consignment",
                    accessor: 'nature_of_consignment',
                    width: 170,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "BOE No",
                    accessor:"boe_no",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "BOE Date",
                    accessor:"boe_date",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "LR No",
                    accessor:"lr_no",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Currency Type",
                    accessor:"currency_type",
                    width: 120,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Amt (Invoice Currency)",
                    accessor:"amt_invoice_currency",
                    width: 170,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Exchange Rate",
                    accessor:"exchange_rate",
                    width: 120,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Amt (INR)",
                    accessor:"amt_inr",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Invoice No",
                    accessor:"invoice_no",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Invoice Date",
                    accessor:"invoice_date",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Vendor Code",
                    accessor:"vendor_code",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Vendor Name",
                    accessor:"vendor_name",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "PO No",
                    accessor:"po_no",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "PO Date",
                    accessor:"po_date",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "PO Amount",
                    accessor:"po_amount",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Credit Period",
                    accessor:"credit_period",
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "Item Description",
                    accessor:"item_description",
                    width: 150,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "User Dept",
                    accessor:"department_name",
                    width: 150,
                    style: { textAlign: 'center' }
                  },
                  {
                    Header: "User Name",
                    accessor:"user_name",
                    style: { textAlign: 'center' }
                  },
                ]}
                defaultSorted={[
                  {
                    id: "document_control_no",
                    desc: true
                  }
                ]}
                manual
                data={data}
                pages={pages} // Display the total number of pages
                loading={loading} // Display the loading overlay when we need it
                onFetchData={this.fetchData} // Request new data when things change
                filterable
                defaultPageSize={10}
                style={height}
                minRows={2}
                minHeight="40px"
                className="-striped -highlight"
              />
              <div style={{marginTop: "10px"}}>
              <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '150px'}} onClick={this.onClick} >
                <SaveIcon />&nbsp;&nbsp;Bulk Update
              </Button>
              </div>
              <Menu
                anchorEl={this.state.anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                open={this.state.open}
                onClose={this.handleClose}
              >
                <MenuItem onClick={this.changeAssignment}>Change Assignment</MenuItem>
              </Menu>
            </Paper>
          }
          {this.state.changeAssignment &&
            <DocumentBulkUpdate checked={this.state.checked} />
          }
        </div>
      </div>
    );
  }
}
   


// WEBPACK FOOTER //
// ./src/components/DocumentList.js